import { Button, FieldLabel } from '../../../ui/2.0/ca-ui';
import { VREditorSubPanel } from './subpanel.js';

export class VREditorCustomOverlayPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'custom-overlays',
      name: 'Custom Overlays',
      instructions: 'Select an overlay to edit, or add a new overlay',
      preview: false,
      assets: vr.assets.customOverlays,
      assetSelectLabel: 'Type',
      allowAddAsset: true,
      addAssetButtonLabel: 'New Custom Overlay',
      onCreateAssetItem: function () {
      }
    });
    this.vr = vr;
    this.editor = editor;
  }

  initControls () {
    this.mediaContainer = new FieldLabel({ label: 'Media' });
    this.mediaContainer.hide();
    super.append(this.mediaContainer.el);

    // gonna need a media picker called change
    this.chooseMediaButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseMediaButton.on(
      'click',
      function () {
        console.log('fired by choose media custom overlay button');
        this.vr.editor.openMediaPicker((data) => this.setMedia(data));
        this.mediaSizeContainer.show();
      }.bind(this)
    );
    this.mediaContainer.setField(this.chooseMediaButton);

    // gonna need a label called media size
    this.mediaSizeContainer = new FieldLabel({ label: 'Media Size' });
    this.mediaSizeContainer.hide();
    super.append(this.mediaSizeContainer.el);
    // gonna need two buttons, one called cover and one called contain
    this.chooseCoverBGOption = new Button({
      icon: 'expand',
      label: 'Cover'
    });
    this.chooseCoverBGOption.on('click', function () {
      this.selected.setBackgroundDisplayType('cover');
      this.chooseCoverBGOption.el.addClass('active');
      this.chooseContainBGOption.el.removeClass('active');
    }.bind(this));
    this.mediaSizeContainer.setField(this.chooseCoverBGOption);

    this.chooseContainBGOption = new Button({
      icon: 'compress',
      label: 'Contain'
    });
    this.chooseContainBGOption.on('click', function () {
      this.selected.setBackgroundDisplayType('contain');
      this.chooseContainBGOption.el.addClass('active');
      this.chooseCoverBGOption.el.removeClass('active');
    }.bind(this));
    this.mediaSizeContainer.setField(this.chooseContainBGOption);

    this.bannerWidthContainer = new FieldLabel({ label: 'Adjust Width' });
    this.bannerWidthContainer.hide();
    super.append(this.bannerWidthContainer.el);
    this.widthSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="400" max="4000" value="400" step="1"></input>'
    );

    this.widthSlider.on(
      'input',
      function () {
        this.selected.setBannerWidth(this.widthSlider.val());
      }.bind(this)
    );

    this.widthSlider.on('mouseup', function () {
      // this.selected.setBannerWidth(this.widthSlider.val());
      this.selected.hide();
      this.selected.show();
      this.selected.render();
    }.bind(this));

    this.bannerWidthContainer.setField(this.widthSlider);

    this.bannerHeightContainer = new FieldLabel({ label: 'Adjust Height' });
    this.bannerHeightContainer.hide();
    super.append(this.bannerHeightContainer.el);

    this.heightSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="400" max="800" value="400" step="1"></input>'
    );

    this.heightSlider.on(
      'input',
      function () {
        this.selected.setBannerHeight(this.heightSlider.val());
      }.bind(this)
    );

    this.heightSlider.on('mouseup', function () {
      this.selected.setBannerHeight(this.heightSlider.val());
    }.bind(this));

    this.bannerHeightContainer.setField(this.heightSlider);
  }

  newObject () {
    return this.vr.addCustomOverlay();
  }

  setObject (obj, fireAssetChange) {
    super.setObject(obj, fireAssetChange);

    if (obj) {
      this.mediaContainer.toggle(obj.asset && obj.asset.allowMedia);
      this.bannerWidthContainer.toggle(obj.asset && obj.asset.allowMedia);
      this.bannerHeightContainer.toggle(obj.asset && obj.asset.allowMedia);
      // set width and height vals here
      if (obj.options.width) {
        this.widthSlider.val(obj.options.width);
      }

      if (obj.options.height) {
        this.heightSlider.val(obj.options.height);
      }
      if (obj.options.image) {
        this.mediaSizeContainer.toggle(obj.asset && obj.asset.allowMedia);
      }
      if (fireAssetChange !== false) {
        this.assetSelect.val(obj.getPropId()).trigger('change');
      }
    } else {
      this.mediaContainer.hide();
      this.mediaSizeContainer.hide();
      this.bannerWidthContainer.hide();
      this.bannerHeightContainer.hide();
      this.widthSlider.val('');
      this.heightSlider.val('');
    }
  }

  setMedia (data) {
    if (data.data) {
      this.getObject().setMedia(data.data.url, data.data.type);
    } else {
      this.getObject().setMedia(data.url, data.type);
    }
  }

  // override
  openPanel(){}
}
